












































import Vue from 'vue';
import NotificationText from '../common/NotificationText/NotificationText.vue';
import CheckBox from '../common/CheckBox/CheckBox.vue';
import { NestedObjectI } from '../../interfaces/NestedObjectI';

export default Vue.extend({
  props: ['getResult', 'directoryStructure'],
  components: {
    NotificationText,
    CheckBox,
  },
  data(): {
    error: boolean;
    parsedDirectory: { name: string; depth: number }[];
    parsedDepth: string[][];
    depthSelected: boolean[];
  } {
    return {
      error: false,
      depthSelected: [],
      parsedDirectory: [],
      parsedDepth: [],
    };
  },
  created() {
    const initialDirectory = this.directoryStructure;
    console.log(initialDirectory);

    const analyzedDirectoryList = this.analyzeObject(initialDirectory, 1);
    const analyzedDepth = analyzedDirectoryList.reduce(
      (acc: string[][], cur: { name: string; depth: number }) => {
        while (acc.length < cur.depth) {
          acc.push([]);
        }
        if (!acc[cur.depth - 1].includes(cur.name)) {
          acc[cur.depth - 1].push(cur.name);
        }
        return acc;
      },
      [],
    );

    this.parsedDirectory = analyzedDirectoryList;
    this.parsedDepth = analyzedDepth;
    this.depthSelected = analyzedDepth.map(() => {
      return false;
    });
  },
  methods: {
    analyzeObject(
      obj: NestedObjectI,
      depth: number,
    ): { name: string; depth: number }[] {
      let newParsedDirectory: { name: string; depth: number }[] = [];

      //nested된 object의 key들에 대해 newParsedDirectory update 진행
      Object.keys(obj).forEach((key: string) => {
        newParsedDirectory.push({ name: key, depth: depth });
        newParsedDirectory = newParsedDirectory.concat(
          this.analyzeObject(obj[key], depth + 1),
        );
      });

      return newParsedDirectory;
    },
    onClickNextButton() {
      if (
        !this.depthSelected.reduce((acc, x) => {
          if (x) {
            return true;
          }
          return acc;
        }, false)
      ) {
        this.error = true;
      }

      let payload = {
        ok: !this.error,
        exampleData: [''],
        parsing_rule: {
          properties: [''],
        },
      };

      const exampleData = [''].concat(
        this.depthSelected.map((isSelected: boolean, index: number) => {
          if (isSelected) {
            return this.parsedDepth[index].join(', ');
          } else {
            return '';
          }
        }),
      );

      payload.exampleData = exampleData;
      payload['parsing_rule'].properties = exampleData.map(() => '');

      this.$emit('pushResult', payload);
    },
  },
  watch: {
    getResult: function (getResult) {
      if (getResult === true) {
        this.onClickNextButton();
      }
    },
  },
});
